import { FC } from "react";
import styled from "styled-components";

import { DATA_E2E_KEY, IStyledAttributes } from "@ryde/shared";

const EmptyPageStyled = styled.div.attrs<IStyledAttributes>({
  [DATA_E2E_KEY]: "empty-page",
})`
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const EmptyPage: FC = () => {
  return <EmptyPageStyled />;
};
